module.exports = __webpack_public_path__ + "static/media/cloud-2.5f185584.svg";